import { render, staticRenderFns } from "./CreateDmPrompt.vue?vue&type=template&id=91cec2e8&lang=pug&"
import script from "./CreateDmPrompt.vue?vue&type=script&lang=js&"
export * from "./CreateDmPrompt.vue?vue&type=script&lang=js&"
import style0 from "./CreateDmPrompt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports